import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { filterSwitch, modeSet } from '../../store/filterSlice';
import { favoritesShow } from '../../store/favoritesSlice';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faList, faGrip, faSquare, faHeart, faCity, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './ModeSwitch.css';
/**
 * Компонент для переключения режима отображения каталога
 * Содержит переключатели экспоненты/активности, вывод плиткой/списком и кнопку вызова избранного
 * Переключатель экспоненты/активности выводится только в том случае если есть и активности и экспоненты
 * @param data результат ответа сервера нужен нам для того чтобы сформировать строку статистики ответа,
 * которую помещаем вместо переключателя экспоненты/активности (если его нет) или под всеми переключателями.
 * Раньше эта строка выводилась в компоненте FilterInfo, но сейчас перенесли её сюда чтобы не было пустого места.
 */
const ModeSwitch = ({ data }) => {
	const { id } = useParams();
	const { t } = useTranslation();
    const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate();
    const mode = useSelector(state => state.filter.mode);
    const event = useSelector(state => state.event);
    const favorites = useSelector(state => state.favorites.list);
	const isFavVisible = useSelector(state => state.favorites.isVisible);
	const [ isActivities, setIsActivities ] = useState(false);
	const [ info, setInfo ] = useState('');

	// Справочная информация о том сколько чего нашли по запросу, которую раньше выводили в FilterInfo
	useEffect(() => {
		if (!data) {
			setInfo('');
			return;
		}

		const area = location.pathname.includes('exhibitors') ? 'exhibitors' : 'activities';
		const count = data?.total ?? 0;
		const query = data?.find ? data.find.replaceAll('|', ' ').replaceAll('|', ' ') : '';
		const where = data?.where ?? 'everywhere';

		let info;
		if (query) {
			if (count) {
				info = t(`${area}.found`, { count, query, where: t('exhibitors.' + where) });
			} else {
				info = t(`${area}.notfound`, { query, where: t('exhibitors.' + where) });
			}
		} else {
			if (count) {
				info = t(`${area}.noquery`, { count });
			} else {
				info = t(`${area}.noqueryfound`);
			}
		}
		
		setInfo(info);

	}, [ data, t, location.pathname ]);

	// Узнаем есть ли что-то в избранном
    useEffect(() => {
        if(event) {
            let list = favorites[event._id];
            let activities = list?.activities ?? [];
            let exhibitors = list?.exhibitors ?? [];
			setIsActivities(activities.length || exhibitors.length);
        } else {
            setIsActivities(false);
        }
    }, [ event, favorites ]);


	const onLocationChange = (path) => {
		if(location.pathname.includes(path)) return;
		dispatch(filterSwitch());
		navigate(`../${path}/${id}`);
	};

	return (<>
		<div className='ModeSwitch'>
			<div>
				{event?.activities_count > 0 ? <>
				<span
					onClick={() => onLocationChange('exhibitors')}
					className={location.pathname.includes('exhibitors') ? 'Selected' : undefined}
				>
					<Icon icon={faCity} size='sm'/>&nbsp;
					{t('mode.exhibitors')}
				</span>
				<span
					onClick={() => onLocationChange('activities')}
					className={location.pathname.includes('activities') ? 'Selected' : undefined}
				>
					<Icon icon={faCalendar} size='sm'/>&nbsp;
					{t('mode.activities')}
				</span>
				</> : <>{info}</>}
			</div>

			<div
				className='fa-layers fa-2x'
				onClick={() => dispatch(modeSet('grid'))}
				style={mode === 'grid' ? {color:'var(--accent-color)'} : {color:'var(--border-color)'}}
			>
				<Icon icon={faSquare} />
				<Icon icon={faGrip} transform="shrink-6" inverse />
			</div>
			
			<div
				className='fa-layers fa-2x'
				onClick={() => dispatch(modeSet('list'))}
				style={mode === 'list' ? {color:'var(--accent-color)'} : {color:'var(--border-color)'}}
			>
				<Icon icon={faSquare} />
				<Icon icon={faList} transform="shrink-8" inverse />
			</div>

			<div
				className='fa-layers fa-2x'
				onClick={() => dispatch(favoritesShow(!isFavVisible))}
				style={isActivities ? {color:'var(--accent-color)'} : {color:'var(--border-color)'}}
			>
				<Icon icon={faSquare}/>
				<Icon icon={faHeart} transform="shrink-8" inverse />
			</div>
		</div>

		{event?.activities_count > 0 && <div className='p'>{info}</div>}
	</>);
};

export default ModeSwitch;
